<template>
  <section>
    <div class="d-flex justify-content-end gap-1">
      <b-button
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        variant="outline-secondary"
        class="mb-75"
        @click="goToEdit"
      >
        Edit
      </b-button>
      <b-button
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        variant="outline-secondary"
        class="mb-75 ml-1"
        @click="printInvoice"
      >
        Print
      </b-button>
    </div>

    <div class="settings-sidebar">
      <h3 style="font-weight: 700">Invoice Settings</h3>
      <hr />

      <h4>Company Information</h4>
      <div style="margin-bottom: 10px">
        <input
          type="checkbox"
          id="company_name"
          v-model="settings.company_name.enabled"
        />
        <label for="company_name" style="margin-left: 5px">Company Name</label>
      </div>
      <div style="margin-bottom: 10px">
        <input
          type="checkbox"
          id="company_email"
          v-model="settings.company_email.enabled"
        />
        <label for="company_email" style="margin-left: 5px"
          >Company Email</label
        >
      </div>
      <div style="margin-bottom: 10px">
        <input
          type="checkbox"
          id="company_phone"
          v-model="settings.company_phone.enabled"
        />
        <label for="company_phone" style="margin-left: 5px"
          >Company Phone</label
        >
      </div>
      <div style="margin-bottom: 10px">
        <input
          type="checkbox"
          id="company_address"
          v-model="settings.company_address.enabled"
        />
        <label for="company_address" style="margin-left: 5px"
          >Company Address</label
        >
      </div>

      <h4>Customer Information</h4>
      <div style="margin-bottom: 10px">
        <input
          type="checkbox"
          id="customer_name"
          v-model="settings.customer_name.enabled"
        />
        <label for="customer_name" style="margin-left: 5px"
          >Customer Name</label
        >
      </div>
      <div style="margin-bottom: 10px">
        <input
          type="checkbox"
          id="customer_email"
          v-model="settings.customer_email.enabled"
        />
        <label for="customer_email" style="margin-left: 5px"
          >Customer Email</label
        >
      </div>
      <div style="margin-bottom: 10px">
        <input
          type="checkbox"
          id="customer_phone"
          v-model="settings.customer_phone.enabled"
        />
        <label for="customer_phone" style="margin-left: 5px"
          >Customer Phone</label
        >
      </div>
      <div style="margin-bottom: 10px">
        <input
          type="checkbox"
          id="customer_address"
          v-model="settings.customer_address.enabled"
        />
        <label for="customer_address" style="margin-left: 5px"
          >Customer Address</label
        >
      </div>

      <h4>Other Settings</h4>
      <div style="margin-bottom: 10px">
        <input
          type="checkbox"
          id="invoice_logo_view"
          v-model="settings.invoice_logo_view.enabled"
        />
        <label for="invoice_logo_view" style="margin-left: 5px"
          >Invoice Logo</label
        >
      </div>
      <div style="margin-bottom: 10px">
        <input type="checkbox" id="notes" v-model="settings.notes.enabled" />
        <label for="notes" style="margin-left: 5px">Notes</label>
      </div>
      <div style="margin-bottom: 10px">
        <input
          type="checkbox"
          id="discount"
          v-model="settings.discount.enabled"
        />
        <label for="discount" style="margin-left: 5px">Discount</label>
      </div>
      <div style="margin-bottom: 10px">
        <input type="checkbox" id="tax" v-model="settings.tax.enabled" />
        <label for="tax" style="margin-left: 5px">Tax</label>
      </div>
      <div style="margin-bottom: 10px">
        <input type="checkbox" id="vat" v-model="settings.vat.enabled" />
        <label for="vat" style="margin-left: 5px">VAT</label>
      </div>
      <div style="margin-bottom: 10px">
        <input
          type="checkbox"
          id="due_amount"
          v-model="settings.due_amount.enabled"
        />
        <label for="due_amount" style="margin-left: 5px">Due Amount</label>
      </div>
    </div>
    <div
      id="content"
      style="
        width: 210mn;
        padding: 20mm;
        margin: auto;
        background: white;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        position: relative;
      "
    >
      <div style="width: 100%; margin: 0; padding: 0; position: relative">
        <div style="width: 100%; max-width: 800px; margin: auto">
          <div
            v-if="settings.invoice_logo_view.enabled && this.form.invoice_logo"
            style="text-align: center; margin-bottom: 20px"
          >
            <div style="margin-bottom: 20px">
              <img
                v-if="this.form.invoice_logo"
                :src="this.form.invoice_logo_view"
                alt="Company Logo"
                height="160"
              />
            </div>
          </div>
          <div v-else-if="!settings.invoice_logo_view.enabled">
            <div style="margin-top: 160px"></div>
          </div>

          <div style="display: flex; justify-content: space-between">
            <div style="width: 37%; overflow-wrap: break-word">
              <h1 style="margin-top: 0px; font-size: 28px">INVOICE</h1>

              <template>
                <div
                  class="flex items-center justify-between w-full"
                  v-if="
                    settings.customer_name.enabled && this.form.customer_name
                  "
                >
                  <b>{{ this.form.customer_name }}</b>
                </div>

                <div
                  v-if="
                    settings.customer_email.enabled && this.form.customer_email
                  "
                >
                  {{ this.form.customer_email }}
                </div>
                <div
                  v-if="
                    settings.customer_phone.enabled && this.form.customer_phone
                  "
                >
                  {{ this.form.customer_phone }}
                </div>
                <div
                  v-if="
                    settings.customer_address.enabled &&
                    this.form.customer_address
                  "
                >
                  {{ this.form.customer_address }}
                </div>
              </template>
            </div>

            <div
              style="text-align: center; width: 26%; overflow-wrap: break-word"
            >
              <div class="margin-bottom:5px">
                <strong>Invoice No.</strong>
                <div style="padding: 5px">{{ this.form.invoice_number }}</div>
              </div>
              <br />
              <div class="margin-bottom:5px">
                <strong>Invoice Date</strong>
                <div style="padding: 5px">
                  {{ formatDate(this.form.issue_date) }}
                </div>
              </div>
              <br />
              <div class="margin-bottom:5px">
                <strong>Due Date</strong>
                <div style="padding: 5px">
                  {{ formatDate(this.form.due_date) }}
                </div>
              </div>
            </div>

            <div style="width: 37%; overflow-wrap: break-word">
              <strong
                v-if="settings.company_name.enabled && this.form.company_name"
                >{{ this.form.company_name }}</strong
              >
              <br />
              <br />
              <div
                v-if="
                  settings.company_address.enabled && this.form.company_address
                "
              >
                {{ this.form.company_address }}
              </div>
              <div
                v-if="settings.company_phone.enabled && this.form.company_phone"
              >
                Phone: {{ this.form.company_phone }}
              </div>
              <div
                v-if="settings.company_email.enabled && this.form.company_email"
              >
                Email: {{ this.form.company_email }}
              </div>
            </div>
          </div>

          <table
            style="width: 100%; border-collapse: collapse; margin-top: 20px"
          >
            <thead>
              <tr style="background-color: #f5f5f5; border: 1px solid black">
                <th
                  style="
                    padding: 10px;
                    text-align: left;
                    border: 1px solid black;
                    font-size: 14px;
                  "
                >
                  SL No.
                </th>
                <th
                  style="
                    padding: 10px;
                    text-align: left;
                    width: 40%;
                    border: 1px solid black;
                    font-size: 14px;
                  "
                >
                  Description
                </th>
                <th
                  style="
                    padding: 10px;
                    text-align: left;
                    border: 1px solid black;
                    font-size: 14px;
                  "
                >
                  Quantity
                </th>
                <th
                  style="
                    padding: 10px;
                    text-align: right;
                    border: 1px solid black;
                    font-size: 14px;
                  "
                >
                  Unit Price ({{ this.form.currency }})
                </th>
                <th
                  style="
                    padding: 10px;
                    text-align: right;
                    border: 1px solid black;
                    font-size: 14px;
                  "
                >
                  Total ({{ Math.ceil(this.form.total) }}) [{{
                    this.form.currency
                  }}]
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in this.form.items"
                :key="index"
                style="border: 1px solid black"
              >
                <td style="text-align: center">{{ index + 1 }}</td>
                <td style="padding: 10px; border: 1px solid black">
                  <div class="font-weight-bold">{{ item.item_name }}</div>
                  <p
                    class="text-truncate"
                    style="max-width: 100%"
                    v-b-tooltip.hover
                    :title="item?.item_description"
                  >
                    {{ item?.item_description }}
                  </p>
                </td>
                <td style="padding: 10px; border: 1px solid black">
                  {{ item.quantity || 0 }}
                </td>
                <td
                  style="
                    padding: 10px;
                    text-align: right;
                    border: 1px solid black;
                  "
                >
                  {{ item.unit_price || 0 }}
                </td>
                <td
                  style="
                    padding: 10px;
                    text-align: right;
                    border: 1px solid black;
                  "
                >
                  {{ item.unit_price * item.quantity || 0 }}
                </td>
              </tr>

              <tr>
                <td
                  colspan="4"
                  style="padding: 10px; text-align: right; border: none"
                >
                  Subtotal
                </td>
                <td
                  style="
                    padding: 10px;
                    text-align: right;
                    border: 1px solid black;
                  "
                >
                  {{ this.form.sub_total_amount }}
                </td>
              </tr>
              <tr v-if="settings.discount.enabled && this.form.discount">
                <td
                  colspan="4"
                  style="padding: 10px; text-align: right; border: none"
                >
                  Discount
                </td>
                <td
                  style="
                    padding: 10px;
                    text-align: right;
                    border: 1px solid black;
                  "
                >
                  {{ this.form.discount }}
                </td>
              </tr>
              <tr v-if="settings.tax.enabled && this.form.tax">
                <td
                  colspan="4"
                  style="padding: 10px; text-align: right; border: none"
                >
                  TAX
                </td>
                <td
                  style="
                    padding: 10px;
                    text-align: right;
                    border: 1px solid black;
                  "
                >
                  {{ this.form.tax }}
                </td>
              </tr>
              <tr v-if="settings.vat.enabled && this.form.vat">
                <td
                  colspan="4"
                  style="padding: 10px; text-align: right; border: none"
                >
                  VAT
                </td>
                <td
                  style="
                    padding: 10px;
                    text-align: right;
                    border: 1px solid black;
                  "
                >
                  {{ this.form.vat }}
                </td>
              </tr>
              <tr v-if="settings.due_amount.enabled && this.form.due_amount">
                <td
                  colspan="4"
                  style="padding: 10px; text-align: right; border: none"
                >
                  Due Amount
                </td>
                <td
                  style="
                    padding: 10px;
                    text-align: right;
                    border: 1px solid black;
                  "
                >
                  {{ this.form.due_amount }}
                </td>
              </tr>
              <tr>
                <td
                  colspan="4"
                  style="padding: 10px; text-align: right; border: none"
                >
                  Grand Total
                </td>
                <td
                  style="
                    padding: 10px;
                    text-align: right;
                    color: red;
                    border: 1px solid black;
                  "
                >
                  <strong>{{ Math.ceil(this.form.total ?? 0) }}</strong>
                </td>
              </tr>
            </tbody>
          </table>

          <div style="margin-top: 30px">
            <h4 style="font-size: 16px; text-transform: capitalize">
              In Words: {{ this.form.currency }}
              {{ numberToWords(Math.ceil(this.form.total ?? 0)) }} Only
            </h4>
            <h4 v-if="settings.notes.enabled && form.notes">
              <strong>Note/Terms</strong>
            </h4>
            <div v-if="settings.notes.enabled && form.notes">
              {{ form.notes }}
            </div>
          </div>

          <h2 style="text-align: center; margin-top: 40px; margin-bottom: 40px">
            Thank You For Your Business
          </h2>
          <br />
          <div
            style="
              width: 100%;
              margin: 0;
              text-align: center;
              display: block;
              bottom: 0;
              left: 0;
            "
          >
            <div
              style="
                margin: 0 auto;
                margin-bottom: 0.5rem;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                width: 80%;
              "
            >
              <span
                v-if="settings.company_phone.enabled && this.form.company_phone"
              >
                <span style="font-weight: bold; color: #145bff">M: </span>
                {{ this.form.company_phone }}
              </span>
              <span
                v-if="settings.company_email.enabled && this.form.company_email"
              >
                <span style="font-weight: bold; color: #145bff">E: </span>
                {{ this.form.company_email }}
              </span>
              <span v-if="settings.invoice_logo_view.enabled">
                <span style="font-weight: bold; color: #145bff">W: </span>
                <a href="https://viserx.com" target="_blank"
                  >www.viserx.com</a
                >
              </span>
            </div>
            <div style="margin-top: 8px; margin-bottom: 3px;">
              {{ this.form.company_name }}, {{ this.form.company_address }}
            </div>
            <div
              style="background-color: #145bff; height: 30px; width: 100%"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Logo from "@core/layouts/components/Logo.vue";
import { heightTransition } from "@core/mixins/ui/transition";
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  BAlert,
  BLink,
  VBToggle,
  BBadge,
  BSpinner,
  BTooltip,
  BFormFile,
  BTable,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { quillEditor } from "vue-quill-editor";
import InvoiceSidebarSendInvoice from "./InvoiceSidebarSendInvoice.vue";
import InvoiceSidebarAddPayment from "./InvoiceSidebarAddPayment.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
export default {
  name: "InvoiceCreateView",
  components: {
    BSpinner,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    BAlert,
    BLink,
    flatPickr,
    vSelect,
    Logo,
    InvoiceSidebarSendInvoice,
    InvoiceSidebarAddPayment,
    ValidationProvider,
    ValidationObserver,
    AppTimeline,
    AppTimelineItem,
    BBadge,
    quillEditor,
    BTooltip,
    BFormFile,
    BTable,
  },
  data() {
    return {
      form: {
        id: null,
        invoice_number: "",
        invoice_logo_view: null,
        invoice_logo: null,
        company_name: "",
        company_email: "",
        company_phone: "",
        company_address: "",
        customer_name: "",
        customer_email: "",
        customer_phone: "",
        customer_address: "",
        issue_date: new Date(),
        due_date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000), // 30 days from now
        status: 1,
        currency: "USD",
        sub_total_amount: 0,
        tax: 0,
        vat: 0,
        discount: 0,
        total: 0,
        due_amount: 0,
        notes: "",
        items: [],
      },
      settings: {
        company_name: { enabled: true },
        company_email: { enabled: true },
        company_phone: { enabled: true },
        company_address: { enabled: true },

        customer_name: { enabled: true },
        customer_email: { enabled: true },
        customer_phone: { enabled: true },
        customer_address: { enabled: true },

        invoice_logo_view: { enabled: true },

        notes: { enabled: true },

        discount: { enabled: true },
        tax: { enabled: true },
        vat: { enabled: true },
        due_amount: { enabled: true },
      },
      loading: false,
      invoiceId: null,
    };
  },
  mixins: [heightTransition],

  mounted() {},
  computed: {},
  async created() {
    if (this.invoiceId || this.$route.params.id) {
      const id = this.invoiceId || this.$route.params.id;
      this.invoiceId = id;
      await this.fetchInvoice(id);
    }
  },
  methods: {
    goToEdit() {
      this.$router.push({
        name: "admin-general-invoice-edit",
        params: { id: this.$route.params.id }, // or replace this.id with the actual id if it's named differently
      });
    },
    numberToWords(num) {
      const ones = [
        "",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
      ];
      const teens = [
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen",
      ];
      const tens = [
        "",
        "",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety",
      ];

      const scales = ["", "thousand", "million", "billion", "trillion"];

      function convert_hundreds(n) {
        let str = "";
        if (n >= 100) {
          str += ones[Math.floor(n / 100)] + " hundred ";
          n %= 100;
        }
        if (n >= 10 && n < 20) {
          str += teens[n - 10] + " ";
        } else {
          if (n >= 20) {
            str += tens[Math.floor(n / 10)] + " ";
            n %= 10;
          }
          if (n > 0) {
            str += ones[n] + " ";
          }
        }
        return str.trim();
      }

      if (num === 0) return "zero";

      let result = "";
      let scaleIndex = 0;

      while (num > 0) {
        const chunk = num % 1000;
        if (chunk > 0) {
          const chunkWords = convert_hundreds(chunk);
          result = `${chunkWords} ${scales[scaleIndex]} ${result}`.trim();
        }
        num = Math.floor(num / 1000);
        scaleIndex++;
      }

      return result.trim();
    },
    printInvoice() {
      const printSection = document.getElementById("content");

      // Create a new window for printing
      const newWindow = window.open("", "_blank", "width=600,height=400");

      // Add styles for printing
      newWindow.document.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            @page {
                size: auto;
                margin: 20px;
              }

            /* Add any styles you want for the printed content here */
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            /* Example: If you want page breaks to happen automatically */
            .page-break { page-break-before: always; }

            /* Ensure the print layout is clean and well-organized */
            @media print {
              body {
                margin: 0;
                padding: 0;
                font-size: 14px;
              }
              .no-print {
                display: none;
              }
              /* Custom styling for your content */
            }
          </style>
        </head>
        <body>
          ${printSection.innerHTML}
        </body>
      </html>
    `);
      newWindow.document.close(); // Close the document for further processing
      newWindow.print(); // Trigger the print dialog

      // Close the print window after printing
      newWindow.addEventListener("afterprint", function () {
        newWindow.close();
      });
    },
    formatDate(date, format = "YYYY-MM-DD") {
      if (!date) return "";

      // If date is a string, convert to Date object
      const dateObj = typeof date === "string" ? new Date(date) : date;

      // Check if valid date
      if (isNaN(dateObj.getTime())) return "";

      const pad = (num) => num.toString().padStart(2, "0");

      const replacements = {
        YYYY: dateObj.getFullYear(),
        MM: pad(dateObj.getMonth() + 1),
        DD: pad(dateObj.getDate()),
        HH: pad(dateObj.getHours()),
        mm: pad(dateObj.getMinutes()),
        ss: pad(dateObj.getSeconds()),
      };

      return format.replace(
        /YYYY|MM|DD|HH|mm|ss/g,
        (match) => replacements[match]
      );
    },

    async fetchInvoice(id) {
      this.loading = true;
      try {
        const { data } = await this.$api.get(`/api/general-invoices/${id}`);
        this.form = {
          ...data,
          issue_date: new Date(data.issue_date),
          due_date: new Date(data.due_date),
        };
        this.form.items.forEach((item) => {
          item.total = (item.quantity || 0) * (item.unit_price || 0);
        });
        this.form.invoice_logo_view = `${process.env.VUE_APP_API_URL}/storage/${data?.invoice_logo}`;
      } catch (error) {
        console.error("Error fetching invoice:", error);
        this.showToast("danger", "Failed to load invoice data");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
@keyframes slideInBottom {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.settings-sidebar {
  position: fixed;
  right: 0;
  top: 207px;
  width: 300px;
  height: 70vh;
  background: white;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 20px;
  overflow-y: auto;
  display: block;
  will-change: transform;

  /* Animation */
  animation: slideInBottom 0.4s ease-out;
}
</style>

